import { Skeleton } from '@/shared/ui/primitives';

export function WizardStepSkeleton() {
  return (
    <div className="flex h-full w-full items-start justify-start pt-3">
      <div className="w-full max-w-xl space-y-2.5" aria-hidden="true">
        <Skeleton className="h-2 w-2/5 rounded-full bg-gradient-to-r from-muted/50 via-muted to-muted/50" />
        <Skeleton className="h-2 w-3/4 rounded-full bg-gradient-to-r from-muted/45 via-muted/80 to-muted/45 [animation-delay:80ms]" />
        <Skeleton className="h-2 w-full rounded-full bg-gradient-to-r from-muted/40 via-muted/70 to-muted/40 [animation-delay:140ms]" />
        <Skeleton className="h-2 w-5/6 rounded-full bg-gradient-to-r from-muted/35 via-muted/65 to-muted/35 [animation-delay:220ms]" />
        <Skeleton className="h-2 w-2/3 rounded-full bg-gradient-to-r from-muted/30 via-muted/60 to-muted/30 [animation-delay:280ms]" />
        <Skeleton className="h-2 w-11/12 rounded-full bg-gradient-to-r from-muted/35 via-muted/65 to-muted/35 [animation-delay:360ms]" />
        <Skeleton className="h-2 w-3/5 rounded-full bg-gradient-to-r from-muted/40 via-muted/70 to-muted/40 [animation-delay:420ms]" />
        <Skeleton className="h-2 w-4/5 rounded-full bg-gradient-to-r from-muted/35 via-muted/65 to-muted/35 [animation-delay:500ms]" />
        <Skeleton className="h-2 w-1/2 rounded-full bg-gradient-to-r from-muted/30 via-muted/60 to-muted/30 [animation-delay:560ms]" />
        <Skeleton className="h-2 w-11/12 rounded-full bg-gradient-to-r from-muted/35 via-muted/65 to-muted/35 [animation-delay:640ms]" />
      </div>
    </div>
  );
}
